/**
 * 配置文件放在json,便于修改
 * @type {{}}
 */

let settings = {};
module.exports = {
  setConfig: function (config) {
    Object.assign(settings, config);
  },
  getConfig: function () {
    if (Object.keys(settings).length == 0) {
      settings = require("./settings");
    }
    return settings;
  },
};
